import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppNotificationToast } from './v1/features/app/components/notification-toast/app-notification-toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppNotificationToast],
  template: `<app-notification-toast /><router-outlet /> `,
})
export class App {}
